import { Navigate, useLocation } from "react-router-dom";
const ProtectedRoute = ({ children }) => {
    const ignoreUrls = ["/view/dashboard"]
    const { pathname } = useLocation();

    const isIgnored = ignoreUrls
        .map(url => url.toLowerCase())
        .includes(pathname.toLowerCase());

    if (isIgnored) {
        return children;
    }

    const token = localStorage.getItem("token");
    return token ? children : <Navigate to="/" replace />;
}

export default ProtectedRoute;